var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.38321 31.5946C-1.19075 23.4975 0.196445 13.3464 6.77563 6.77143C14.8682 -1.31597 27.989 -1.31597 36.0815 6.77143C42.6607 13.3464 44.0479 23.4975 39.4739 31.5946L25.0057 57.2072C23.4339 59.9898 19.4233 59.9898 17.8514 57.2072L3.38321 31.5946ZM21.4282 32.8608C28.6193 32.8608 34.4495 27.0349 34.4495 19.8474C34.4495 12.6599 28.6193 6.834 21.4282 6.834C14.2372 6.834 8.407 12.6599 8.407 19.8474C8.407 27.0349 14.2372 32.8608 21.4282 32.8608Z","fill":"#4338CA","stroke":"#4338CA","strokeWidth":"1.41176","key":0}),React.createElement("path",{"d":"M14.4286 55.5C8.8694 56.3196 5 58.1471 5 60.27C5 63.1584 12.1634 65.5 21 65.5C29.8366 65.5 37 63.1584 37 60.27C37 58.2206 33.394 56.4465 28.1429 55.5888","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","key":1})]);
}

Pin.defaultProps = {"width":"43","height":"67","viewBox":"0 0 43 67","fill":"none"};

module.exports = Pin;

Pin.default = Pin;
